import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { JalaliDateCalculatorService } from 'ngx-persian';
import { ConfigService, PaymentStatus } from 'src/app/core';
import { ShoppingCartHandlerService } from 'src/app/feature/payment/services';
import { OrderComponent } from '../../../../shared/components/order/order.component';

@Component({
  selector: 'app-download-order',
  templateUrl: './download-order.component.html',
  styleUrls: ['./download-order.component.sass'],
})
export class DownloadOrderComponent extends OrderComponent implements OnInit {
  public get baseUrl(): string {
    return this.configService.getBaseUrl();
  }

  public getDownloadLinkPDF(id: number) {
    return this.baseUrl + 'dow';
  }

  public paymentStatus = PaymentStatus;
  readonly shoppingCartHService: any;

  constructor(
    private jalaliDateCalculator: JalaliDateCalculatorService,
    private configService: ConfigService,
    private snackbar: MatSnackBar,

    shoppingCartHandler: ShoppingCartHandlerService,
    dialog: MatDialog,
    router: Router
  ) {
    super(shoppingCartHandler, dialog, router);
  }

  // -------------------------------Public Methods|

  public toJalaliDate(date?: Date) {
    if (!date) return 'نامشخص';
    const jDate = this.jalaliDateCalculator.convertToJalali(new Date(date));
    return `${jDate.year}/${jDate.month}/${jDate.day}`;
  }

  public copyOrderHashToClipboard() {
    navigator.clipboard.writeText(this.orderObject.hash?.toString()!);
    this.snackbar.open(' کپی شد.', '', {
      horizontalPosition: 'end',
      duration: 500,
    });
  }
  // ------------------------------Private Methods|
}
